import {Component, Prop, Mixins, Watch} from 'vue-property-decorator';
import IconsMixin from '@/mixins/IconsMixin';
import ProductMixin from '@/mixins/ProductMixin';
import {
    ProductServiceItem,
    SelectedServiceProduct,
    Product,
    FieldName,
    CloudBackupType
} from '../ProductsAndServicesModels';
import ContentCard from "@/products-and-services/products-type/ContentCard.vue";
import BigNumber from 'bignumber.js';

@Component({
    components: {
        ContentCard,
    },
})
export default class CloudBackup extends Mixins(IconsMixin, ProductMixin) {
    @Prop({type: Array, required: false})
    private products!: Product[];
    @Prop({type: String, required: false})
    private serviceTypeId!: string;
    @Prop({type: String, required: false})
    private serviceId!: string;
    @Prop({type: String, required: false})
    private serviceCatId!: string;
    @Prop({type: Boolean, required: false, default: false})
    private isFullCart!: boolean;

    @Watch("products")
    checkProducts() {
        this.setValues();
    }

    private selectedValue?: any = {};
    private cloudEmail: string = '';

    get email(): Product {
        return this.products.filter(x => x.typeId === CloudBackupType.EMAIL.valueOf())[0];
    }

    get discount(): Product {
        return this.products.filter(x => x.typeId === CloudBackupType.DISCOUNT.valueOf())[0];
    }

    get cloudOptions(): Product[] {
        const cloudSizes = this.products.filter(x => x.typeId === CloudBackupType.STORAGE_OPTIONS.valueOf());
        const discount = this.discount;
        return cloudSizes.map(product => {
            const productAmount = new BigNumber(product.amount);
            const discountAmount = new BigNumber(discount.amount);
            product.amount =  (productAmount.plus(discountAmount)).toFixed(2);
            return product;
        });
    }

    get inCart() {
        return this.isInCart(this.getSelectedProduct());
    }

    getSelectedProduct(): SelectedServiceProduct {
        return this.getSelectedServiceProduct(this.email);
    }

    getSelectedDisplayedProduct(): ProductServiceItem {
        const {serviceId, serviceTypeId, serviceCatId, productId, productCatId} = this.getSelectedServiceProduct(this.email);
        return {
            index: 0,
            serviceId,
            serviceTypeId,
            serviceCatId,
            productId,
            productCatId,
            name: "Cloud Backup",
            description: "Keep all your memories and important information safe and backed up worry free.",
            totalAmount: -99999.00,
            imageUrl: this.email.imageUrl,
            learnMoreUrl: this.email.learnMoreUrl
        };
    }

    getSelectedServiceProduct(product: Product) {

        const {productId, productCatId} = product;
        const {serviceTypeId, serviceId, serviceCatId} = this;
        return {serviceId, serviceTypeId, serviceCatId, productId, productCatId}
    }

    async save(product: Product) {
        for (const option of this.cloudOptions) {
            await this.removeFromCart({...this.getSelectedServiceProduct(option), noRefetch: true });
        }
        await this.removeFromCart({ ...this.getSelectedServiceProduct(this.discount), noRefetch: true });
        await this.addToCart({ ...this.getSelectedServiceProduct(product), noRefetch: true });
        await this.addToCart(this.getSelectedServiceProduct(this.discount));
    }
    async saveEmail() {
        const value = this.jsonStringifyValue([{ field: FieldName.CLOUD_BACKUP_EMAIL, value: this.cloudEmail }]);
        await this.removeFromCart({ ...this.getSelectedServiceProduct(this.email), noRefetch: true });
        await this.addToCart({ ...this.getSelectedServiceProduct(this.email), value });
    }

    setValues() {
        const selectedAmount = this.products.filter(p => p.typeId === CloudBackupType.STORAGE_OPTIONS.valueOf() && p.isSelected);
        if (selectedAmount[0]) {
            this.selectedValue = selectedAmount[0].catId;
        } else {
            this.selectedValue = {};
        }

        const email = (this.jsonParseFromValue(this.email.value));
        if (email && email[0]) {
            this.cloudEmail = email[0].value;
        }
    }

    created() {
        this.setValues();
    }
}
